(function ($) {
  /**
   * Object for management Dietitian Consultation product page
   */
  window.Dietitian = {
    init: function () {
      var $this = this;

      $('.product-form__cart-submit').on('click', function (e) {
        e.preventDefault();
        $this.addToCart();
      });
    },

    addToCart: function () {
      CartUtil.ajaxget('/cart.js', function (cart) {
        var attrs = cart.attributes,
          toAdd = ModifyHelpers.prepareSort(cart);

        if (!cart.item_count.length) {
          CartUtil.updateAttrs({}, function () {
            CartUtil.updateNote('', function () {});
          });
        }
        CartUtil.clear();

        toAdd.dietitian.push({
          id: $('.product-form select[name="id"]').val(),
          qty: 1,
          properties: {
            healthieFulfills: 1,
          },
        });
        attrs['healthieScheduler'] = 'No';

        ModifyHelpers.sortCartAndSubmit(toAdd, attrs);
      });
    },
  };
})(jQuery);
